import { FC } from 'react';

import { FormTextField } from 'src/components/FormTextField/FormTextField';

import classes from './Fields.module.scss';

export const CarFields: FC = () => {
  return (
    <div className={classes.fields}>
      <FormTextField
        name='model'
        size='medium'
        label='Марка'
        required
        fullWidth
        helperText='Марка машины, на которой приедешь'
      />
      <FormTextField
        name='number'
        size='medium'
        label='Номер'
        required
        fullWidth
        helperText='Номер машины, на которой приедешь'
      />
    </div>
  );
};
